import { createElement, ElementType, ReactNode } from 'react';

import { DataRow, isDataRow, Row } from '@paragon/layout-models';

import CarriedComponentName from './CarriedComponentName';
import { ComponentNameFormatter } from './ColoredComponentName';
import ColoredName from './ColoredName';
import { LoadName } from './LoadName';
import ParapetLoadName from './ParapetLoadName';

export interface DisplayNameProviderProps<T> {
  displayName: ReactNode;
  row: DataRow<T>;
}

const nameProviders: Record<string, ElementType<DisplayNameProviderProps<any>>> = {
  parapetLoad: ParapetLoadName,
  load: LoadName,
  jackGirderConnection: CarriedComponentName,
  analogLink: ColoredName,
  member: ColoredName,
  brace: ColoredName,
  platePair: ColoredName,
  analyzableMember: ColoredName,
  featurePatternTrussDesign: ComponentNameFormatter,
  profileTrussDesign: ComponentNameFormatter,
};

interface PrimaryRowTextProps {
  row: Row;
  displayName: ReactNode;
}

export default function PrimaryRowText({ row, displayName }: PrimaryRowTextProps) {
  return isDataRow(row) && row.type in nameProviders
    ? createElement(nameProviders[row.type], { row, displayName })
    : displayName;
}
